const HISTORY_KEY = 'talkr_ai_history';
export const HISTORY_MAX_ENTRIES = 60;

const isEntry = (value) => Boolean(
    value && typeof value === 'object'
    && typeof value.id === 'string'
    && typeof value.createdAt === 'string'
    && Array.isArray(value.blocks)
    && Array.isArray(value.steps)
);

export const readHistory = () => {
    try {
        const stored = JSON.parse(window.localStorage.getItem(HISTORY_KEY));
        return Array.isArray(stored) ? stored.filter(isEntry) : [];
    } catch (_) {
        return [];
    }
};

export const writeHistory = (entries) => {
    let toStore = entries.slice(0, HISTORY_MAX_ENTRIES);

    while (true) {
        try {
            window.localStorage.setItem(HISTORY_KEY, JSON.stringify(toStore));
            return toStore;
        } catch (_) {
            if (toStore.length === 0) return toStore;
            toStore = toStore.slice(0, Math.floor(toStore.length * 0.75));
        }
    }
};

export const createHistoryEntry = (fields) => ({
    id: Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8),
    createdAt: new Date().toISOString(),
    botName: null,
    prompt: '',
    // 'ready' | 'clarification' | 'failed'
    status: 'ready',
    message: null,
    groups: [],
    steps: [],
    notes: [],
    categories: [],
    referencedVariables: [],
    stats: null,
    blocks: [],
    blocksRemovedAt: null,
    error: null,
    source: 'ai',
    // Id of the previous entry of the same conversation, followed back by Resume
    previousEntryId: null,
    ...fields,
});
